// extracted by mini-css-extract-plugin
module.exports = {"anchorTabs":"AnchorTabs_anchorTabs__ymFLM"};